import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Audio Icon
 *
 * @file Audio.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Audio = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 18 16" {...props}>
    <g fill="none">
      <path
        d="M11.3228 8.54459H10.3228V8.53491L10.323
          8.52524L11.3228 8.54459ZM11.3228 14.3587L10.323
          14.378L10.3228 14.3684V14.3587H11.3228ZM6.67764
          14.3629H7.67764V14.3833L7.67681 14.4036L6.67764
          14.3629ZM6.67764 8.5404L7.67681 8.49968L7.67764
          8.52003V8.5404H6.67764ZM4.91012 8.92824L5.41012
          9.79426L4.91012 8.92824ZM4.17538 9.35244L4.67538
          10.2185L4.17538 9.35244ZM4.17538 13.5508L4.67538
          12.6848L4.17538 13.5508ZM13.0906 8.92859L13.5906
          8.06256L13.0906 8.92859ZM11.5163 9.35487C11.9565
          9.35487 12.3141 9.0024 12.3226 8.56395L10.323
          8.52524C10.3355 7.87652 10.8649 7.35487 11.5163
          7.35487V9.35487ZM12.0969 9.35487H11.5163V7.35487H12.0969V9.35487ZM12.6776
          9.35487H12.0969V7.35487H12.6776V9.35487ZM11.8711
          8.54841C11.8711 8.99381 12.2322 9.35487 12.6776
          9.35487V7.35487C13.3368 7.35487 13.8711 7.88923
          13.8711 8.54841H11.8711ZM13.325 10.2186L12.5906
          9.79461L13.5906 8.06256L14.325 8.48653L13.325 10.2186ZM13.7788
          11.8986V11.0046H15.7788V11.8986H13.7788ZM12.5906 13.1087L13.325
          12.6847L14.325 14.4167L13.5906 14.8407L12.5906 13.1087ZM12.6776
          13.5484C12.2322 13.5484 11.8711 13.9095 11.8711
          14.3549H13.8711C13.8711 15.014 13.3368 15.5484
          12.6776 15.5484V13.5484ZM12.0969 13.5484H12.6776V15.5484H12.0969V13.5484ZM11.5163
          13.5484H12.0969V15.5484H11.5163V13.5484ZM12.3226 14.3393C12.3141
          13.9009 11.9565 13.5484 11.5163 13.5484V15.5484C10.8649 15.5484
          10.3355 15.0267 10.323 14.378L12.3226 14.3393ZM10.3228
          14.3587V8.54459H12.3228V14.3587H10.3228ZM6.48425 13.5484C6.04981
          13.5484 5.69601 13.8915 5.67847 14.3222L7.67681 14.4036C7.65085
          15.0406 7.12711 15.5484 6.48425 15.5484V13.5484ZM5.90323
          13.5484H6.48425V15.5484H5.90323V13.5484ZM5.32296
          13.5484H5.90323V15.5484H5.32296V13.5484ZM6.12941 14.3549C6.12941
          13.9095 5.76835 13.5484 5.32296 13.5484V15.5484C4.66378 15.5484
          4.12941 15.014 4.12941 14.3549H6.12941ZM4.67538 12.6848L5.41012
          13.109L4.41012 14.8411L3.67538 14.4169L4.67538 12.6848ZM4.22134
          11.0049V11.8984H2.22134V11.0049H4.22134ZM5.41012 9.79426L4.67538
          10.2185L3.67538 8.48641L4.41012 8.06221L5.41012 9.79426ZM5.32296
          9.35487C5.76834 9.35487 6.12941 8.99381 6.12941 8.54841H4.12941C4.12941
          7.88923 4.66379 7.35487 5.32296 7.35487V9.35487ZM5.90323
          9.35487H5.32296V7.35487H5.90323V9.35487ZM6.48425 9.35487H5.90323V7.35487H6.48425V9.35487ZM5.67847
          8.58111C5.69602 9.01174 6.04982 9.35487 6.48425 9.35487V7.35487C7.1271
          7.35487 7.65085 7.8627 7.67681 8.49968L5.67847 8.58111ZM7.67764
          8.5404V14.3629H5.67764V8.5404H7.67764ZM4.41012 8.06221C4.23642
          8.1625 4.12941 8.34784 4.12941 8.54841H6.12941C6.12941 9.06237
          5.85522 9.53728 5.41012 9.79426L4.41012 8.06221ZM2.22134
          11.0049C2.22134 9.96592 2.77562 9.00589 3.67538 8.48641L4.67538
          10.2185C4.39442 10.3807 4.22134 10.6805 4.22134 11.0049H2.22134ZM3.67538
          14.4169C2.77562 13.8974 2.22134 12.9374 2.22134 11.8984H4.22134C4.22134
          12.2228 4.39442 12.5226 4.67538 12.6848L3.67538 14.4169ZM4.12941
          14.3549C4.12941 14.5554 4.23642 14.7408 4.41012 14.8411L5.41012
          13.109C5.85522 13.366 6.12941 13.8409 6.12941 14.3549H4.12941ZM13.5906
          14.8407C13.7642 14.7405 13.8711 14.5553 13.8711 14.3549H11.8711C11.8711
          13.8408 12.1454 13.3657 12.5906 13.1087L13.5906 14.8407ZM15.7788
          11.8986C15.7788 12.9374 15.2246 13.8973 14.325 14.4167L13.325 12.6847C13.6058
          12.5226 13.7788 12.2229 13.7788 11.8986H15.7788ZM14.325 8.48653C15.2246 9.00594
          15.7788 9.96584 15.7788 11.0046H13.7788C13.7788 10.6804 13.6058 10.3807 13.325
          10.2186L14.325 8.48653ZM13.8711 8.54841C13.8711 8.34798 13.7642 8.16278 13.5906
          8.06256L12.5906 9.79461C12.1454 9.53756 11.8711 9.06251 11.8711 8.54841H13.8711Z"
        fill="currentcolor"
      />
      <path
        d="M2.97292 11.3333L1.85381 11.1299C1.73079 10.5475 1.66669 9.94541 1.66669
          9.33336C1.66669 6.47523 3.06442 3.83421 5.33336 2.40514C7.6023 0.976077
          10.3978 0.976077 12.6667 2.40514C14.9356 3.83421 16.3334 6.47523 16.3334
          9.33336C16.3334 9.93381 16.2717 10.5247 16.1532 11.0967L15.1524 11.2983"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </SvgIcon>
);

export default Audio;
